<template>
  <div class="multi-color-fission">
    <div class="mcf-toolbar">
      <button class="scg-back-btn" @click="goBack">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        返回宣传图生成
      </button>
      <span class="scg-mode-tag">多色裂变</span>
      <button class="scg-generate-all-btn" @click="generateAllFission">
        全部裂变
      </button>
      <button
        class="scg-fission-all-btn"
        @click="goToMainImage"
      >用于主图</button>
      <button class="scg-download-page-btn" @click="downloadPageImages">下载全页图片</button>
      <button class="clear-task-btn" @click="onClearTask">清空任务</button>
    </div>

    <div v-for="item in activeProducts" :key="item.product.id" class="mcf-product-section">
      <div class="mcf-product-header">
        <span class="mcf-product-name">{{ item.product.name }}</span>

        <div class="mcf-source-thumbs">
          <span class="mcf-source-label">宣传图:</span>
          <div v-for="sel in getSelectedSlots(item.pi)" :key="sel.key" class="mcf-source-thumb"
            :class="{
              selected: typeof sel.customIdx !== 'number' && workbench.isPromoSelectedForMain(sel.pi, sel.si),
              'is-custom': typeof sel.customIdx === 'number'
            }"
            @click="typeof sel.customIdx === 'number' ? null : workbench.togglePromoForMain(sel.pi, sel.si)"
            @mouseenter="typeof sel.customIdx === 'number' ? showCustomPreview($event, sel.pi, sel.customIdx) : null"
            @mouseleave="hideCustomPreview"
          >
            <img v-if="typeof sel.customIdx === 'number'"
              :src="workbench.getCustomPromoImageUrl(sel.pi, sel.customIdx)" />
            <img v-else-if="workbench.imageGen.genResults[sel.pi]?.[sel.si]?.url"
              :src="workbench.imageGen.genResults[sel.pi][sel.si].url" />
            <div class="mcf-thumb-check" v-if="typeof sel.customIdx !== 'number'">
              <svg v-if="workbench.isPromoSelectedForMain(sel.pi, sel.si)" viewBox="0 0 24 24" fill="#165dff" width="14" height="14">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              <svg v-else viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" width="14" height="14">
                <rect x="3" y="3" width="18" height="18" rx="3"/>
              </svg>
            </div>
          </div>
          <button class="mcf-upload-promo" @click="triggerPromoUpload(item.pi)" title="上传自定义宣传图">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
              <polyline points="17 8 12 3 7 8"/>
              <line x1="12" y1="3" x2="12" y2="15"/>
            </svg>
            <span>上传宣传图</span>
          </button>
        </div>

        <button class="mcf-add-color" @click="workbench.addFissionColor(item.pi)">+ 添加颜色</button>
        <button
          class="mcf-download-zip-btn"
          :disabled="!hasAnyFissionImage(item.pi)"
          @click="downloadZip(item.pi)"
        >下载全部</button>
        <button class="clear-product-btn" @click="workbench.clearProduct(item.pi)">清空</button>
      </div>

      <div v-for="(color, ci) in (workbench.imageGen.fissionColors[item.pi] || [])" :key="color.id" class="mcf-color-block">
        <FissionColorRow
          :productIndex="item.pi"
          :colorIndex="ci"
          :color="color"
          :canRemove="(workbench.imageGen.fissionColors[item.pi] || []).length > 1"
          @remove="workbench.removeFissionColor(item.pi, ci)"
        />
        <div class="mcf-color-gen-row">
          <button class="mcf-gen-color-btn" @click="workbench.generateAllFissionForColor(item.pi, ci)">
            生成此颜色裂变
          </button>
        </div>
      </div>
    </div>

    <div class="mcf-product-section mcf-extras-section">
      <div class="mcf-product-header">
        <span class="mcf-product-name">其他</span>
        <button class="mcf-add-color" @click="workbench.addFissionExtra()">+ 添加图</button>
        <button
          class="mcf-download-zip-btn"
          :disabled="workbench.getFissionExtrasAllImageUrls().length === 0"
          @click="downloadFissionExtrasZip"
        >下载全部</button>
        <button class="clear-product-btn" @click="workbench.clearAllFissionExtras()">清空</button>
      </div>

      <div v-if="workbench.fissionExtras.length === 0" class="mcf-extras-empty">
        点击"+ 添加图"上传原宣传图和裂变参照图，用于用户自定义制作裂变图
      </div>

      <div v-else class="mcf-extras-list">
        <div v-for="extra in workbench.fissionExtras" :key="extra.id" class="mcf-extras-row">
          <div class="mcf-extras-header">
            <div class="mcf-extras-shared">
              <span class="mcf-extras-shared-label">共享参考：</span>
              <div class="fcr-uploads mcf-extras-uploads">
                <div
                  class="fcr-ref-upload"
                  :class="{ 'has-image': !!extra.refImage }"
                  @click="triggerExtraUpload(extra.id, 'refImage')"
                >
                  <template v-if="extra.refImage">
                    <img :src="extra.refImage" class="fcr-ref-img" />
                    <div class="fcr-ref-overlay"><span>替换</span></div>
                  </template>
                  <template v-else>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <line x1="12" y1="8" x2="12" y2="16"/>
                      <line x1="8" y1="12" x2="16" y2="12"/>
                    </svg>
                    <span>颜色参考</span>
                  </template>
                </div>
                <div
                  class="fcr-ref-upload fcr-detail-upload"
                  :class="{ 'has-image': !!extra.detailImage }"
                  @click="triggerExtraUpload(extra.id, 'detailImage')"
                >
                  <template v-if="extra.detailImage">
                    <img :src="extra.detailImage" class="fcr-ref-img" />
                    <div class="fcr-ref-overlay"><span>替换</span></div>
                  </template>
                  <template v-else>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                    <span>细节参考</span>
                  </template>
                </div>
              </div>
            </div>
            <div class="mcf-extras-header-actions">
              <button class="mcf-gen-color-btn" :disabled="!extra.refImage" @click="workbench.generateAllForFissionExtra(extra.id)">
                生成全部裂变
              </button>
              <button class="mcf-extras-remove" title="移除该组" @click="workbench.removeFissionExtra(extra.id)">&times;</button>
            </div>
          </div>

          <div class="mcf-extras-promos">
            <div v-for="(promo, pi) in extra.promos" :key="promo.id" class="mcf-extras-promo">
              <button
                v-if="extra.promos.length > 1"
                class="mcf-promo-remove"
                title="移除该宣传图"
                @click="workbench.removeFissionExtraPromo(extra.id, promo.id)"
              >&times;</button>
              <div class="fcr-uploads mcf-extras-uploads">
                <div
                  class="fcr-ref-upload"
                  :class="{ 'has-image': !!promo.baseImage }"
                  @click="triggerExtraUpload(extra.id, 'baseImage', promo.id)"
                >
                  <template v-if="promo.baseImage">
                    <img :src="promo.baseImage" class="fcr-ref-img" />
                    <div class="fcr-ref-overlay"><span>替换</span></div>
                  </template>
                  <template v-else>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <line x1="12" y1="8" x2="12" y2="16"/>
                      <line x1="8" y1="12" x2="16" y2="12"/>
                    </svg>
                    <span>原宣传图{{ extra.promos.length > 1 ? pi + 1 : '' }}</span>
                  </template>
                </div>
              </div>
              <div class="mcf-extras-arrow">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="18" height="18">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </div>
              <div class="fcr-results">
                <div class="fcr-result-slot">
                  <template v-if="promo.result.loading">
                    <div class="scg-loading-ring small">
                      <svg viewBox="0 0 36 36">
                        <circle class="ring-bg" cx="18" cy="18" r="16" fill="none" stroke="#e5e6eb" stroke-width="3"/>
                        <circle class="ring-fg" cx="18" cy="18" r="16" fill="none" stroke="#165dff" stroke-width="3"
                          :stroke-dasharray="100" :stroke-dashoffset="100 - promo.result.progress" stroke-linecap="round"
                          transform="rotate(-90 18 18)"/>
                      </svg>
                      <span class="ring-text">{{ Math.round(promo.result.progress) }}%</span>
                    </div>
                  </template>
                  <template v-else-if="promo.result.url">
                    <img :src="promo.result.url" class="fcr-result-img" @click="workbench.openLightbox(promo.result.url, [promo.result.url])" />
                    <div class="fcr-result-actions">
                      <button class="fcr-action-btn" title="重新生成" @click.stop="workbench.generateOneFissionExtra(extra.id, promo.id)">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12">
                          <polyline points="23 4 23 10 17 10"/>
                          <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                        </svg>
                      </button>
                      <button class="fcr-action-btn delete" title="删除" @click.stop="workbench.clearFissionExtraResult(extra.id, promo.id)">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="12" height="12">
                          <line x1="18" y1="6" x2="6" y2="18"/>
                          <line x1="6" y1="6" x2="18" y2="18"/>
                        </svg>
                      </button>
                    </div>
                  </template>
                  <template v-else>
                    <div class="scg-empty-slot clickable" @click="workbench.generateOneFissionExtra(extra.id, promo.id)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="#c9cdd4" stroke-width="1.5" width="20" height="20">
                        <rect x="3" y="3" width="18" height="18" rx="2"/>
                        <circle cx="8.5" cy="8.5" r="1.5"/>
                        <polyline points="21 15 16 10 5 21"/>
                      </svg>
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <button class="mcf-add-promo-btn" @click="workbench.addFissionExtraPromo(extra.id)">+ 添加宣传图</button>
          </div>
        </div>
      </div>
    </div>

    <ImageCropper
      :visible="cropState.visible"
      :imageSrc="cropState.imageSrc"
      @confirm="onCropConfirm"
      @cancel="onCropCancel"
      @restore="onCropRestore"
    />

    <Teleport to="body">
      <div
        v-if="previewState.visible"
        class="mcf-preview-popover"
        :class="['placement-' + previewState.placement]"
        :style="{ top: previewState.top + 'px', left: previewState.left + 'px' }"
        @mouseenter="keepCustomPreview"
        @mouseleave="hideCustomPreview"
      >
        <span
          class="mcf-preview-arrow"
          :style="{ left: previewState.arrowLeft + 'px' }"
          aria-hidden="true"
        ></span>
        <div class="mcf-preview-header">
          <span>自定义宣传图 {{ previewState.customIdx + 1 }}</span>
        </div>
        <img :src="previewState.url" class="mcf-preview-img" />
        <div class="mcf-preview-actions">
          <button class="mcf-preview-btn" @click="startCustomCrop(previewState.pi, previewState.customIdx); hideCustomPreview()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
              <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"/>
              <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"/>
            </svg>
            <span>裁剪</span>
          </button>
          <button
            v-if="workbench.customPromoImages[previewState.pi]?.[previewState.customIdx]?.originalUrl"
            class="mcf-preview-btn"
            @click="workbench.restoreCustomPromoImage(previewState.pi, previewState.customIdx); hideCustomPreview()"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
              <polyline points="23 4 23 10 17 10"/>
              <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
            </svg>
            <span>还原</span>
          </button>
          <button class="mcf-preview-btn danger" @click="workbench.removeCustomPromoImage(previewState.pi, previewState.customIdx); hideCustomPreview()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
              <polyline points="3 6 5 6 21 6"/>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
            </svg>
            <span>删除</span>
          </button>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { computed, reactive } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import FissionColorRow from './FissionColorRow.vue'
import ImageCropper from '@/components/common/ImageCropper.vue'

const workbench = useWorkbenchStore()

const onClearTask = () => {
  if (!confirm('确定要清空当前任务吗？\n\n所有产品（A/B/C）的上传图片和所有生成结果都会被删除，且无法恢复。')) return
  workbench.clearAllTask()
}

const activeProducts = computed(() => {
  const indices = [...new Set(workbench.selectedFissionSlots.map(s => s.pi))]
  return indices
    .map(i => ({ pi: i, product: workbench.products[i] }))
    .filter(item => item.product)
})

const getSelectedSlots = (pi) => {
  return workbench.selectedFissionSlots.filter(s => s.pi === pi)
}

const generateAllFission = () => {
  const indices = [...new Set(workbench.selectedFissionSlots.map(s => s.pi))]
  for (const pi of indices) {
    workbench.generateAllFissionForProduct(pi)
  }
  workbench.generateAllFissionExtras()
}

const triggerExtraUpload = (id, field, promoId = null) => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.onchange = async (e) => {
    const file = e.target.files?.[0]
    if (file) {
      try {
        await workbench.setFissionExtraImage(id, field, file, promoId)
      } catch (err) {
        alert('上传失败: ' + (err?.message || '未知错误'))
      }
    }
  }
  input.click()
}

const downloadFissionExtrasZip = async () => {
  try {
    await workbench.downloadFissionExtrasZip()
  } catch (e) {
    alert('下载失败: ' + e.message)
  }
}

const goToMainImage = () => {
  workbench.enterMainImageGen()
}

const goBack = () => {
  workbench.imageGen.step = 2
}

const hasAnyFissionImage = (pi) => {
  const colors = workbench.imageGen.fissionColors[pi] || []
  return colors.some(color => (color.results || []).some(r => r.url))
}

const triggerPromoUpload = (pi) => {
  const input = document.createElement('input')
  input.type = 'file'
  input.accept = 'image/*'
  input.onchange = async (e) => {
    const file = e.target.files?.[0]
    if (file) {
      try {
        await workbench.addCustomPromoImage(pi, file)
      } catch (err) {
        alert('上传失败: ' + (err?.message || '未知错误'))
      }
    }
  }
  input.click()
}

const downloadZip = async (pi) => {
  try {
    await workbench.downloadProductZip(pi)
  } catch (e) {
    alert('下载失败: ' + e.message)
  }
}

const downloadPageImages = async () => {
  try {
    await workbench.downloadAllProductsZip()
  } catch (e) {
    alert('下载失败: ' + e.message)
  }
}

const cropState = reactive({ visible: false, imageSrc: '', pi: -1, customIdx: -1 })

const previewState = reactive({
  visible: false,
  top: 0,
  left: 0,
  arrowLeft: 0,
  placement: 'bottom',
  url: '',
  pi: -1,
  customIdx: -1
})
let hideTimer = null

const showCustomPreview = (event, pi, customIdx) => {
  if (hideTimer) { clearTimeout(hideTimer); hideTimer = null }
  const url = workbench.getCustomPromoImageUrl(pi, customIdx)
  if (!url) return
  const rect = event.currentTarget.getBoundingClientRect()
  const POPOVER_W = 220
  const POPOVER_H = 280
  const ARROW_GAP = 10
  const margin = 8
  let placement = 'bottom'
  let top = rect.bottom + ARROW_GAP
  if (top + POPOVER_H > window.innerHeight) {
    top = rect.top - POPOVER_H - ARROW_GAP
    placement = 'top'
  }
  let left = rect.left + rect.width / 2 - POPOVER_W / 2
  if (left < margin) left = margin
  if (left + POPOVER_W > window.innerWidth - margin) left = window.innerWidth - POPOVER_W - margin
  const arrowLeft = Math.max(20, Math.min(POPOVER_W - 20, rect.left + rect.width / 2 - left))
  previewState.top = top
  previewState.left = left
  previewState.arrowLeft = arrowLeft
  previewState.placement = placement
  previewState.url = url
  previewState.pi = pi
  previewState.customIdx = customIdx
  previewState.visible = true
}

const keepCustomPreview = () => {
  if (hideTimer) { clearTimeout(hideTimer); hideTimer = null }
}

const hideCustomPreview = () => {
  if (hideTimer) clearTimeout(hideTimer)
  hideTimer = setTimeout(() => { previewState.visible = false }, 120)
}

const startCustomCrop = (pi, customIdx) => {
  const url = workbench.getCustomPromoImageUrl(pi, customIdx)
  if (!url) return
  cropState.imageSrc = url
  cropState.pi = pi
  cropState.customIdx = customIdx
  cropState.visible = true
}

const onCropConfirm = (croppedBase64) => {
  workbench.applyCropToCustomPromoImage(cropState.pi, cropState.customIdx, croppedBase64)
  cropState.visible = false
}

const onCropRestore = () => {
  workbench.restoreCustomPromoImage(cropState.pi, cropState.customIdx)
  cropState.visible = false
}

const onCropCancel = () => {
  cropState.visible = false
}
</script>
